import type { FaireProductEntity } from "../../entity_types/product";

export const p_ksha8cajze: FaireProductEntity = {
  token: "p_ksha8cajze",
  type: "product",
  name: "Organic Long Sleeve Baby gown and knotted Beanie Gift Set",
  brandToken: "b_9fk13xj7jn",
  brandName: "MONAG",
  imageUrl:
    "https://cdn.faire.com/fastly/a0851c7725070fd87e8010e2c8ebc2817a73fb90b6ab207fc0728bc13de98b7b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d8c28fb78ca6ecf9b7ebceed92cca19e8c72ea86fd86da8dfc46913dd39173dd.jpeg",
    "https://cdn.faire.com/fastly/71c57b878cd3fdc2a4b9cc6ce69bd155e4da5814404f04c97b70c9ffc4adaff9.jpeg",
    "https://cdn.faire.com/fastly/e4846525e0244c32041b07044e623fa1bccba7f2f4d8a078f430362b0ad56f62.jpeg",
    "https://cdn.faire.com/fastly/380a4cbbb2db1a2ae09853ca3142ff034a726ff2254f08fb1c398ef57563ca76.jpeg",
    "https://cdn.faire.com/fastly/d376bf6071527fdc310779ebacd7afffb95a12fb3e58c49d8d5b192b4913cae3.jpeg",
  ],
  priceDollars: 14.95,
  description:
    "This Organic Cotton long sleeve baby gown and knotted cap set in soft and comfortable premium quality fine interlock fabric. The Interlock Long Sleeve Baby Gown is comfortable, breathable and durable for longer use and multiple wears. This baby gown features lap shoulder that expands easily over the head making it quite easy for changing and folding gloves to cover hands. Our baby gowns have 1/2\" elastic at the bottom for easy dressing. MATERIAL QUALITY: Soft, breathable organic cotton which is soft and comfortable\nSET INCLUDES: One long-sleeve baby gown and one coordinating knotted cap\nDESIGN FEATURES: folding gloves that can be easily folded to cover the baby's hands, keeping your baby's hand warm and preventing scratches, thoughtful details like elastic bottoms and convenient closures\nVERSATILE  Perfect for everyday use, layering, or special occasions with classic neutral, earth tone colors.Bundle the different colors to make fun newborn essentials gift set.\n",
  tags: [],
  msrpDollars: 29.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:10.910Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
